/* src/app/components/notification-banner/notification-banner.component.scss */
.container {
  position: fixed;
  height: 3.675rem;
  z-index: 100;
  background-color: #1E31BF;
  color: #FFFFFF;
  padding: 0 1.5rem;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  margin-left: 6.25rem;
  width: calc(100% - 6.25rem);
}
.container.info {
  background-color: #1E31BF;
}
.container.warning {
  background-color: #D1691F;
}
.container.danger {
  background-color: #DB2121;
}
.container.success {
  background-color: #108467;
}
.container.alt {
  background-color: #AC376F;
}
.container .content {
  font-family: "PoppinsSemi Bold";
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  flex-grow: 1;
}
.container .close {
  position: absolute;
  cursor: pointer;
  right: 3rem;
}
.container .close ::ng-deep button.button-icon {
  fill: #FFFFFF;
}
/*# sourceMappingURL=notification-banner.component.css.map */
